import React from "react";
import "../styles/sections.css";

const VideoInstructions = ({ translations, videoId }) => {
  console.log("VideoInstructions Translations:", translations); // Debugging

  return (
    <section className="section video-instructions gradient-background">
      <div className="container">
        <h2>{translations?.videoTitle || "How to Use V-Assistant"}</h2>
        <p>{translations?.videoDescription || "Watch this short tutorial to learn how to use V-Assistant to improve your Vinted listings."}</p>

        <div className="video-wrapper">
          <iframe
            width="800"
            height="450"
            src={`https://www.youtube.com/embed/${videoId}`}
            title={translations?.videoTitle || "Video"}
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </div>
      </div>
    </section>
  );
};

export default VideoInstructions;